import {
  AutoComplete,
  Avatar,
  Button,
  Form,
  Image,
  Input,
  Select,
  Spin,
  Tag,
} from "antd";
import axios from "axios";
import { debounce } from "lodash";
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { authenticateToken } from "../../../utils/auth";
import { getImgUrl, getParamValue } from "../../../utils/index";
import Loading from "../../common/Loader";
import PaginationTwo from "../../common/PaginationTwo";
import { useLocation } from "react-router";
import Empty from "../../common/Empty";
import { responseNotification } from "../../../utils/notify";
import {
  BarcodeOutlined,
  CheckOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { useSelector } from "react-redux";

const { Option } = Select;

const FreeProductAssignList = ({
  selectedProduct,
  setSelectedProduct,
  shop,
}): ReactElement => {
  const { shopInfo } = useSelector((state) => (state as any)?.authReducer);
  const [limit, setLimit] = useState(16);
  const [type, setType] = useState("JC_MART");
  const [productData, setProductData] = useState<any>({
    loading: false,
    item: [],
  });
  const [selectedProductForEdit, setSelectedProductForEdit] =
    useState(undefined);
  const [status, setStatus] = useState("");
  const [key, setKey] = useState("");
  const [visible, setVisible] = useState(undefined);
  const [productOptions, setProductOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [categoriesOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [categoryId, setCategoryId] = useState<any>();
  const [brandsOptions, setBrandsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [brandId, setBrandId] = useState<any>();
  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });
  const [shopId, setShopId] = useState<any>();

  const router = useLocation();
  const page = getParamValue(router?.search, "page");

  const [form] = Form.useForm();

  const reseAllFieldData = () => {
    setKey("");
    setType("");
    setShopId("");
    setCategoryId("");
    setBrandId("");
    form.resetFields();
  };

  const fetchProducts = useCallback(() => {
    try {
      setProductData({ loading: true, item: [] });
      const url =
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/product?` +
        `page=${page || 0}` +
        `&limit=${limit || 16}` +
        (status ? `&status=${status}` : ``) +
        (key ? `&key=${key}` : ``) +
        (categoryId ? `&categoryId=${categoryId}` : ``) +
        (brandId ? `&brandId=${brandId}` : ``) +
        (type ? `&type=${type}` : ``) +
        (shop ? `&shopId=${shop}` : ``);
      // (`&isDeleted=${false}`);

      fetch(url, {
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setProductData({ loading: false, item: data });
        })
        .catch(() => {
          setProductData({ loading: true, item: [] });
        });
    } catch (error) {
      setProductData({ loading: true, item: [] });
      console.log(error, "error");
    }
  }, [limit, page, status, categoryId, brandId, shopId, key, type, shopId]);

  const getProductOptions = useCallback(
    async (val) => {
      setProductOptions({ loading: false, list: [] });

      if (val) {
        setProductOptions({ loading: true, list: [] });
        const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

        const res = await axios.get(
          `${encodedUri}/admin/product/search?page=0&limit=20` +
            (val ? `&key=${val}` : ``) +
            (type ? `&type=${type}` : ``) +
            (status ? `&status=${status}` : ``) +
            (shopId ? `&shopId=${shopId}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setProductOptions({
          loading: false,
          list: res?.data?.keys?.map((product: { name: any }) => {
            return {
              value: product?.name,
              label: product?.name,
            };
          }),
        });
      }
    },
    [status, type]
  );

  const getCategoriesOptions = useCallback(
    async (key) => {
      if (shopInfo?.type === "JC_MART") {
        setCategoriesOptions({ loading: true, list: [] });
        const res = await axios.get(
          `${process.env.REACT_APP_CATALOG_READER_API}/hub/categories/admin?id=${shopInfo?.hubId}`,
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setCategoriesOptions({
          loading: false,
          list: res?.data?.categories?.map((category: any) => {
            return {
              value: category?.category?.id,
              label: category?.category?.title,
            };
          }),
        });
      } else {
        setCategoriesOptions({ loading: true, list: [] });
        const res = await axios.get(
          `${process.env.REACT_APP_CATALOG_READER_API}/category/search?page=0&limit=20&type=${type}&isParent=true&key=${key}`,
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setCategoriesOptions({
          loading: false,
          list: res?.data?.categories?.map(
            (category: { id: any; title: any }) => {
              return {
                value: category?.id,
                label: category?.title,
              };
            }
          ),
        });
      }
    },
    [key]
  );

  const getBrandsOptions = useCallback(
    async (val?: string) => {
      setBrandsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/brand/search?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``) +
          (shopId ? `&shopId=${shopId}` : ``),

        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setBrandsOptions({
        loading: false,
        list: res?.data?.brands?.map((brand) => {
          return {
            id: brand?.id,
            name: brand?.name,
          };
        }),
      });
    },
    [type]
  );

  // const getShopsOptions = useCallback(
  //   async (val?: string) => {
  //     setShopsOptions({ loading: true, list: [] });

  //     const res = await axios.get(
  //       `${process.env.REACT_APP_CATALOG_READER_API}/shop/admin/search?page=0&limit=20` +
  //         (type ? `&type=${type}` : ``) +
  //         (val ? `&key=${val}` : ``) +
  //         (shopId ? `&shopId=${shopId}` : ``),
  //       {
  //         headers: {
  //           Authorization: `Bearer ${authenticateToken()}`,
  //         },
  //       }
  //     );
  //     setShopsOptions({
  //       loading: false,
  //       list: res?.data?.shops?.map((shop) => {
  //         return {
  //           id: shop?.id,
  //           name: shop?.name,
  //         };
  //       }),
  //     });
  //   },
  //   [type]
  // );

  useEffect(() => {
    fetchProducts();
  }, [fetchProducts]);

  useEffect(() => {
    if (type) {
      getCategoriesOptions("");
      getBrandsOptions();
    }
  }, [type]);

  const fetchRef = useRef(null);

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }
      if (type) {
        if (value) {
          if (field === "product") getProductOptions(value);
          else if (field === "category") getCategoriesOptions(value);
          else if (field === "brand") getBrandsOptions(value);
          // else if (field === "shop") getShopsOptions(value);
        }
      } else {
        responseNotification("Select a type before search", "warning");
      }
    };

    return debounce(loadOptions, 800);
  }, [getBrandsOptions, getCategoriesOptions, getProductOptions, type]);

  useEffect(() => {
    setShopId("");
    setShopsOptions({ list: [], loading: false });
    setBrandId("");
    setBrandsOptions({ list: [], loading: false });
    setCategoryId("");
    setCategoriesOptions({ list: [], loading: false });
    form.resetFields([
      "product_search",
      "category_search",
      "brand_search",
      "shop_search",
    ]);
  }, [type]);

  useEffect(() => {
    setSelectedProductForEdit(undefined);
  }, [visible]);

  return (
    <div className="product-lists">
      <section className="search_area">
        <Form form={form} className="search_form">
          <Form.Item name="product_search" initialValue={key}>
            <AutoComplete
              onSearch={(e) => handleSearch(e, "product")}
              onSelect={(val) => setKey(val.toString())}
              options={productOptions?.list}
              defaultActiveFirstOption={false}
              notFoundContent={
                productOptions?.loading ? <Spin size="small" /> : null
              }
            >
              <Input.Search
                size="large"
                placeholder="Search by Name"
                onSearch={(val) => {
                  setKey(val);
                }}
                enterButton
                loading={productOptions.loading}
                pattern={`[0-9]`}
                maxLength={11}
              />
            </AutoComplete>
          </Form.Item>

          <Form.Item name="category_search">
            <Select
              showSearch
              placeholder="Filter by Category"
              optionFilterProp="children"
              onChange={(val) => setCategoryId(val)}
              onSearch={(e) => handleSearch(e, "category")}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {categoriesOptions?.list?.map((category, i) => (
                <Option value={category?.value} key={i}>
                  {category?.label}
                </Option>
              ))}
            </Select>
          </Form.Item>

          <Form.Item name="brand_search">
            <Select
              showSearch
              placeholder="Filter by Brand"
              optionFilterProp="children"
              onChange={(val) => setBrandId(val)}
              onSearch={(e) => handleSearch(e, "brand")}
              filterOption={(input, option) =>
                option.children
                  .toString()
                  .toLowerCase()
                  .indexOf(input.toLowerCase()) >= 0
              }
            >
              {brandsOptions.list.length ? (
                <Option value={""}>All Brands</Option>
              ) : undefined}{" "}
              {brandsOptions.list.map((brand, i) => (
                <Option value={brand.id} key={i}>
                  {brand.name}
                </Option>
              ))}
            </Select>
          </Form.Item>
        </Form>
        <div className="search_btn">
          <Button type="primary" size="large" danger onClick={reseAllFieldData}>
            Reset
          </Button>
        </div>
      </section>
      <div className="product-list-item-area white-bg section-padding-bottom">
        <div className="container-fluid">
          {/* <div className="row">
            <div className="col-lg-12">
              <div className="product-list-items-inner-content">
                <div className="single-product-wrapper">
                  <div className="single-product-heading major">
                    <span>Product Name</span>
                  </div>
                  <div className="single-product-heading major">
                    <span>Stock & Price</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Status</span>
                  </div>
                  <div className="single-product-heading">
                    <span>Action</span>
                  </div>
                </div>
              </div>
            </div>
          </div> */}
          <div className="row">
            {productData.loading ? (
              <Loading />
            ) : (
              <div className="col-lg-12 product-table">
                <div className="product-table-area">
                  {productData.item?.products?.length ? (
                    productData?.item?.products?.map(
                      (product: any, index: number) => (
                        <React.Fragment key={index}>
                          <div className="single-product-wrapper">
                            <div className="single-product major">
                              <Avatar
                                shape="square"
                                size={50}
                                src={
                                  <Image
                                    src={getImgUrl(product?.productImage)}
                                    height={50}
                                  />
                                }
                                className="mr-3"
                              />
                              <span className="name">{product?.name}</span>
                            </div>
                            <div className="single-product major">
                              <div className="">
                                {product?.variations?.length
                                  ? product?.variations?.map(
                                      (variant, index) => (
                                        <React.Fragment key={index}>
                                          <div className="d-flex _text-center mb-1">
                                            {variant?.barCode ? (
                                              <Tag className="d-flex align-items-center">
                                                <BarcodeOutlined className="mr-1" />{" "}
                                                {variant?.barCode}
                                              </Tag>
                                            ) : product?.barCode ? (
                                              <Tag className="d-flex align-items-center">
                                                <BarcodeOutlined className="mr-1" />{" "}
                                                {product?.barCode}
                                              </Tag>
                                            ) : undefined}
                                            <Tag
                                              color={
                                                variant?.stock < 10
                                                  ? `red`
                                                  : `green`
                                              }
                                            >
                                              {variant?.variationName?.toUpperCase()}{" "}
                                              : {variant?.stock || 0}
                                            </Tag>
                                            <Tag>
                                              MRP{" "}
                                              {variant?.price?.currencyCode ||
                                                "Tk"}
                                              {variant?.price
                                                ?.discountedPrice ||
                                                variant?.price?.mrp}
                                              {variant?.price
                                                ?.discountedPrice &&
                                                variant?.price
                                                  ?.discountedPrice !==
                                                  variant?.price?.mrp && (
                                                  <span className="text-danger">
                                                    {" "}
                                                    <del>
                                                      {variant?.price
                                                        ?.currencyCode || "Tk"}
                                                      {variant?.price?.mrp}
                                                    </del>
                                                  </span>
                                                )}
                                            </Tag>
                                          </div>
                                        </React.Fragment>
                                      )
                                    )
                                  : undefined}
                              </div>
                            </div>

                            <div className="single-product">
                              <span
                                className={`radius-btn ${
                                  product?.deleted === false
                                    ? "active-btn"
                                    : "deleted-btn"
                                }`}
                              >
                                {product?.deleted === false
                                  ? "Active"
                                  : "Deleted"}
                              </span>
                            </div>

                            <div className="single-product">
                              <Button
                                type="primary"
                                className="mx-1"
                                onClick={() => setSelectedProduct(product)}
                                disabled={
                                  product?.deleted ||
                                  !product?.variations?.[0]?.stock
                                }
                                danger
                              >
                                {selectedProduct?.id === product?.id ? (
                                  <CheckOutlined />
                                ) : (
                                  <PlusOutlined />
                                )}
                              </Button>
                            </div>
                          </div>
                        </React.Fragment>
                      )
                    )
                  ) : (
                    <Empty data="Products" />
                  )}
                </div>
              </div>
            )}
          </div>
          <PaginationTwo
            {...productData.item}
            limit={limit}
            page={productData?.item?.currentPageNumber || 0}
          />
        </div>
      </div>
    </div>
  );
};

export default FreeProductAssignList;
